const PREVIEW_DIRECTORY = 'preview';
const SECURE_PREVIEW_DIRECTORY = 'secure-preview';

const isPreview = location => location.pathname.startsWith(`/${PREVIEW_DIRECTORY}/`) || location.pathname.startsWith(`/${SECURE_PREVIEW_DIRECTORY}/`) || location.pathname.startsWith(`/es/${PREVIEW_DIRECTORY}/`) || location.pathname.startsWith(`/es/${SECURE_PREVIEW_DIRECTORY}/`);

module.exports = {
  isPreview,
  PREVIEW_DIRECTORY,
  SECURE_PREVIEW_DIRECTORY,
};
